<div id="update-container">
  <h1>No {{ title }}</h1>
  <img id="logo" alt="logo" class="img" />
</div>
